// extracted by mini-css-extract-plugin
export var logo = "_lc-2";
export var logoWrapper = "_lc-1";
export var strip = "_lc-0";